const authentication = require('../../../react-azure-adb2c2').default;



export const list = (values: any) => {

    const token = authentication.getAccessToken();
    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/rent/contracts/check`;

    // let url = `http://localhost:5000/api/v1/rent/contracts/check`;
    // alert(url)
    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}




export const changelist = (values: any) => {

    const token = authentication.getAccessToken();
    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/rent/contracts/check/changelist/` + values.rent_contract_id;

    // let url = `http://localhost:5000/api/v1/rent/contracts/check/changelist/` + values.rent_contract_id;

    return fetch(url, {
        method: 'get',
        // body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}


export const check_changelist = (values: any) => {

    const token = authentication.getAccessToken();
    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/rent/contracts/check/changecheck/` + values.rent_contract_id;

    // let url = `http://localhost:5000/api/v1/rent/contracts/check/changecheck/` + values.rent_contract_id;
    // alert(url)
    return fetch(url, {
        method: 'get',
        // body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}


export const parking = (values: any) => {

    const token = authentication.getAccessToken();
    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/rent/contracts/check/parking`;
    // let url = `http://localhost:5000/api/v1/rent/contracts/check/parking`;
    // alert(url)
    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}
export const net = (values: any) => {

    const token = authentication.getAccessToken();
    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/rent/contracts/check/net`;
    // let url = `http://localhost:5000/api/v1/rent/contracts/check/net`;
    // alert(url)
    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}
export const energization = (values: any) => {

    const token = authentication.getAccessToken();
    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/rent/contracts/check/energization`;
    // let url = `http://localhost:5000/api/v1/rent/contracts/check/energization`;
    // alert(url)
    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}







export const electronics = (values: any) => {

    const token = authentication.getAccessToken();
    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/rent/contracts/check/electronics`;
    // let url = `http://localhost:5000/api/v1/rent/contracts/check/electronics`;
    // alert(url)
    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}


export const wifi = (values: any) => {

    const token = authentication.getAccessToken();
    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/rent/contracts/check/wifi`;
    // let url = `http://localhost:5000/api/v1/rent/contracts/check/wifi`;
    // alert(url)
    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}

export const autolock = (values: any) => {

    const token = authentication.getAccessToken();
    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/rent/contracts/check/autolock`;
    // let url = `http://localhost:5000/api/v1/rent/contracts/check/autolock`;
    // alert(url)
    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}


export const owner_tel = (values: any) => {

    const token = authentication.getAccessToken();
    // const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + values.id

    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/rent/contracts/check/ownertel`;
    // let url = `http://localhost:5000/api/v1/rent/contracts/check/ownertel`;
    // alert(url)
    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}


export const detail = (Id: number) => {

    const url = `https://homestationapi.azurewebsites.net/api/RentContracts/` + Id;

    const token = authentication.getAccessToken();

    return fetch(url, {
        headers: { 'Authorization': 'Bearer ' + token }
    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}

export const check_completed = (values: any) => {
    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/rent/contracts/check/completed`;
    // let url = `http://localhost:5000/api/v1/rent/contracts/check/completed`;
    const token = authentication.getAccessToken();

    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}

export const check_completed_cancel = (values: any) => {
    console.log(values)
    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/rent/contracts/check/completedcancel`;
    // let url = `http://localhost:5000/api/v1/rent/contracts/check/completedcancel`;
    const token = authentication.getAccessToken();
    // alert(JSON.stringify(values))
    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));


}



export const download_pint = (values: any) => {
    console.log(values)
    let url = process.env.REACT_APP_API_BASE_URL + `/api/v1/rent/contracts/check/pint`;
    // let url = `http://localhost:5000/api/v1/rent/contracts/check/pint`;
    const token = authentication.getAccessToken();
    // alert(JSON.stringify(values))
    // alert(url)
    return fetch(url, {
        method: 'get',
        // body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    }).then(response => response.blob())
        .then(payload => ({ payload }))
        // .then(res => res.json())
        // .then(payload => ({ payload }))
        .catch(error => ({ error }));


}
